import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';


@Injectable()
export class GlobalVars {
	private appVersion: string = '1.0.52.202604231802';
	baseUrl: string = '';
	loggedCongreso: boolean = false;
	tokenCongreso: string = '';
	tipoCongreso: any;
	userCongreso: any = null;
	nombreCongreso: string = '';
	apellidosCongreso: string = '';	
	idEvento: any;

	// Local
	//apiRootBackend: 	string = 'https://usoeventos.test/api';
	//assetsRoot: 		string = 'https://usoeventos.test/assets/app'

	// Staging
	//apiRootBackend: 	string = 'https://usoeventos.stagingdo3.com/api';
	//assetsRoot: 		string = 'https://usoeventos.stagingdo3.com/assets/app'

	// Producción
	apiRootBackend: 	string = 'https://www.uso.es/eventos/api';
	assetsRoot: 		string = 'https://www.uso.es/eventos/assets/app'	

	
	private storageKeyPrefixNotifications: string = 'read-notifications-seccion-';
	private storageKeyPrefixEventNotifications: string = 'read-notifications-evento-';
	defaultImage: string = this.assetsRoot + "/congreso/default-image.png";
  
	constructor(
		public storage: Storage,
	) {


	}



	getLoggedCongreso(){
		//return (this.loggedCongreso || this.storage.get("loggedCongreso"));
		return (this.loggedCongreso);
	}

	setLoggedCongreso(value: boolean){
		this.loggedCongreso=value;
	}

	getTokenCongreso(){
		return this.tokenCongreso;
	}

	getTipoCongreso(){
		return this.tipoCongreso;
	}

	setTipoCongreso(value: any){
		this.tipoCongreso = value;
		if (this.userCongreso) {
			this.userCongreso['tipo'] = value;
			this.storage.set('userCongreso', this.userCongreso);
		}
	}

	getApiRootBackend() {
		return this.apiRootBackend;
	}

	getAssetsRoot() {
		return this.assetsRoot;
	}

	getAppVersion() {
		return this.appVersion;
	}

	getStorageKeyPrefixNotifications(seccionId: string) {
		return this.storageKeyPrefixNotifications + seccionId;
	}

	getStorageKeyEventNotifications(eventId: string) {
		return this.storageKeyPrefixEventNotifications + eventId;
	}

	getUserCongreso(){
		return this.userCongreso;
	}
	getIdEvento(){
		return this.idEvento;	
	}

	setUserCongreso(value: any){
		this.userCongreso = value;
		this.tipoCongreso = value ? value['tipo'] : null;
		if (value) {
			this.storage.set('userCongreso', value);
		}
	}

	setNombreCongreso(value: string){
		this.nombreCongreso = value;
	}

	setApellidosCongreso(value: string){
		this.apellidosCongreso = value;
	}

	setTokenCongreso(value: string){
		this.tokenCongreso = value;
	}
	setIdEvento(value: any){
		this.idEvento = value;
	}

	getKK(){
		return "KK";
	}


	loginCongreso(data: any){
		this.loggedCongreso=true;
		this.storage.set('loggedCongreso', true);
		this.userCongreso = data;		
		this.tokenCongreso = data['token']
		this.tipoCongreso = data['tipo'];
		this.nombreCongreso = data['nombre'];
		this.apellidosCongreso = data['apellidos'];
		this.idEvento = data['idevento'];
		this.storage.set('userCongreso', data);
	}
	logoutCongreso(){
		this.loggedCongreso=false;
		this.tipoCongreso = null;
		this.storage.set('loggedCongreso', false);
		this.storage.remove('userCongreso');
		//this.idEvento = null;
	}

	
	openUrl(url:string) {
		window.open(url, '_blank');
	 }
	 
	getDefaultImage() {
		return this.defaultImage;
	}

	/*isBrowser(){
		return (this.platform.is('core'));
	}


	isLogged(){
		return (this.getToken() != null);
	}

  	getToken(){
  		var lsIdToken = (window.localStorage.getItem('id_token')) ? window.localStorage.getItem('id_token') : null;
  		return lsIdToken;
  	}

  	getDeviceToken(){
    	return window.localStorage.getItem('device_token');
  	}*/
}


// WEBPACK FOOTER //
// ./src/providers/global-vars/globalVars.ts